import React from 'react'

const CardLogo = props => {
    return (
        <button className="flex w-60 mr-7.5 mb-7.5 border bg-white border-vp-lightbrown hover:border-primary hover:bg-primary-light justify-center items-center rounded-md h-21.5">
            <img src={props.logo} alt="" />
        </button>
    )
}


export default CardLogo
